import 'react-app-polyfill/ie11';
import React, { useEffect, useState } from 'react';
import { useForm, Controller } from "react-hook-form";
import { Container, Typography, InputLabel, Paper, Divider, Button, Grid } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl'
import { bindActionCreators } from 'redux';
import { useDispatch, useSelector } from "react-redux";
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import SaveIcon from '@material-ui/icons/Save';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { MerchantActions, NotificationActions } from '../../../store';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';

const style = theme => ({
    root: {
        height: '100%',
        overflow: 'hidden'
    },
    paper: {
        overflow: 'hidden',
        paddingTop: '10px',
        marginBottom: '4px'
    },
    form: {
        height: '100%',
        padding: '25px'
    },
    loadingBackground: theme.loadingBackground,
    loading: theme.loading
})

const merchantsSelector = (state) => state.Merchants;
const IdentitySelector = (state) => state.Identity;

const MerchantApplication = (props) => {
    // useDispatch で store に紐付いた dispatch を取得。
    const dispatch = useDispatch();
    const merchantActions = bindActionCreators(MerchantActions, dispatch);
    const notificationActions = bindActionCreators(NotificationActions, dispatch);

    // useSelector で store の state を取得。
    const { editing, nowWainting } = useSelector(merchantsSelector);
    //const { token } = useSelector(IdentitySelector);
    const { token, userData } = useSelector(IdentitySelector);

    const { control, errors, handleSubmit, watch ,register } = useForm();
    const { classes, data } = props;

    // 削除確認ダイアログ表示フラグ
    const [dlgOpen, setDlgOpen] = React.useState(false);

    /**
     *
     * 戻るボタン押下時の処理
     *
     */
    const onBackClick = () => {
        props.onCancel();
    }

    /**
     *
     * 削除ボタン押下時の処理
     *
     */
    const onDeleteClick = () => {
        // 削除確認ダイアログを表示
        setDlgOpen(true);
    };

    /**
     *
     * 削除確認ダイアログでの「はい」ボタン押下時の処理（削除実行）
     * 
     */
    const onDlgYesClick = () => {
        // 一旦、削除確認ダイアログを閉じる
        setDlgOpen(false);
        // 申請削除処理を実行
        merchantActions.delete(token, editing)
            .then(data => {
                notificationActions.showSuccess('削除しました。');
                props.onCancel();
            })
            .catch(e => {
                notificationActions.showError(e.message);
            });
    }

    /**
     *
     * 削除確認ダイアログでの「いいえ」ボタン押下時の処理（キャンセル）
     *
     */
    const onDlgNoClick = () => {
        // 削除確認ダイアログを閉じる
        setDlgOpen(false);
    };

    /**
     *
     * 申請OKボタン押下時の処理
     *
     */
    const onApproveClick = () => {
        // 申請承認処理を実行
        merchantActions.approve(token, editing)
            .then(data => {
                notificationActions.showSuccess('申請を承認しました。');
                props.onCancel();
            })
            .catch(e => {
                notificationActions.showError(e.message);
            });
    }

    // 事業形態
    var businessForm = '';
    switch (editing.business_form) {
        case 1:
            // 法人
            businessForm = <FormattedMessage id={"Merchant.Corporate"} />;
            break;
        case 2:
            // 個人事業主
            businessForm = <FormattedMessage id={"Merchant.IndividualBusiness"} />;
            break;
    }

    // 法人種別コード種別
    var shopCdtype = '';
    switch (editing.shop_cd_type) {
        case 1:
            // OKICA独自
            shopCdtype = <FormattedMessage id={"Merchant.CorporateCodeTypeOkica"} />;
            break;
        case 2:
            // JPQR
            shopCdtype = <FormattedMessage id={"Merchant.CorporateCodeTypeJPQR"} />;
            break;
    }

    // 申請OKボタン表示
    var applicationOK_disabled = true;
    // システム管理者と沖縄ICカードのみ
    if (userData.role == 1 || userData.role == 2) {
        applicationOK_disabled = false;
    }

    return (
        <Container className={classes.root} maxWidth={false}>
            <Paper className={classes.paper}>
                <Grid container className={classes.form} spacing={2}>   
                    <Grid item xs={12}>
                        <Typography component="h1" variant="inherit">{<FormattedMessage id="Merchant.ConfirmApplicationDetails" />}</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.HelperTextOK"} /></InputLabel>
                    </Grid>
                    <Grid item xs={12}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.HelperTextDelete"} /></InputLabel>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography component="h2" variant="inherit">{<FormattedMessage id="Merchant.ApplicationDetails" />}</Typography>
                        <Divider />
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.ContactName"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.contact_name}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.ContactNameInFurigana"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.contact_f_name}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.PhoneNumber"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.contact_tel}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.MailAddress"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.mail_adress}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.BusinessForm"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{businessForm}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.CorporateName"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.corporat_name}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.CorporateNameInFurigana"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.corporat_f_name}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.CorporateNumber"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.corporat_no}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.StoreCodeLevel1"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.shop_cd_1}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.StoreCodeLevel2"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.shop_cd_2}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.CorporateCodeType"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{shopCdtype}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.Name"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.merchant_name}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.NameInEng"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.merchant_e_name}</InputLabel>
                    </Grid>
                  
                    <Grid item xs={4}>
                        <Button fullWidth variant="contained" size="medium"
                            startIcon={<ArrowBackIosIcon />}
                            onClick={onBackClick}><FormattedMessage id="Button.Back" /></Button>
                    </Grid>
                    <Grid item xs={4}>
                        <Button fullWidth variant="contained" size="medium" color="secondary"
                            onClick={onDeleteClick}
                            startIcon={<DeleteForeverIcon />}><FormattedMessage id="Button.Delete" /></Button>
                    </Grid>
                    <Grid item xs={4}>
                        <Button fullWidth variant="contained" size="medium" color="primary"
                            onClick={onApproveClick}
                            disabled={applicationOK_disabled}
                            endIcon={<SaveIcon />}><FormattedMessage id="Button.ApplicationOK" /></Button>
                    </Grid>
                </Grid>
            </Paper>

            <Dialog
                open={dlgOpen}
                onClose={onDlgNoClick}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"確認"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        申請を削除しますか？
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onDlgYesClick} color="primary">
                        はい
                    </Button>
                    <Button onClick={onDlgNoClick} color="primary" autoFocus>
                        いいえ
                    </Button>
                </DialogActions>
            </Dialog>

        </Container>
    )
}

export default withStyles(style, { withTheme: true })(MerchantApplication);
